/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import moment from 'moment';
import { OrdersService } from '../../../../../services';
import { Render, Spinner } from '../../../../../components';

const ModalDetails = ({ date, onClose }) => {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);

  const fetchData = async () => {
    if (isLoading) return;
    setIsLoading(true);
    setData([]);

    try {
      const response = await OrdersService.moderator.findAllFinished({ date });
      setData(response);

    } catch (error) {
      toast.error(String(error));
    }
    setIsLoading(false);
  }

  useEffect(() => {
    if (date) fetchData();
  }, [date]);

  return (
    <main className="p-4 w-full bg-white max-w-5xl rounded-2xl relative">
      <button
        type="button"
        className="p-1.5 rounded-full hover:bg-gray5 transition-colors absolute top-2 right-2"
        onClick={onClose}
        disabled={isLoading}
      >
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-5 h-5 text-text">
          <path strokeLinecap="round" strokeLinejoin="round" d="M6 18 18 6M6 6l12 12" />
        </svg>
      </button>

      <h1 className="text-3xl font-bold font-sans">Viajes Realizados</h1>
      <p className="my-2 bg-[#FFF0E2] font-black text-lg text-orange max-w-max px-2 py-1 rounded-lg">
        { moment(date).format('DD-MM-YYYY') }
      </p>

      <table className="text-left border-collapse w-full">
        <thead>
          <tr className="[&>th]:bg-gray5 [&>th]:px-1 [&>th]:py-2 [&>th]:leading-4 [&>th]:whitespace-pre [&>th]:max-w-36 text-default font-semibold align-center">
            <th className="pl-4 rounded-l-lg">Cliente</th>
            <th>Fecha y hora{'\n'}del viaje</th>
            <th>Placa de{'\n'}vehículo</th>
            <th>Conductor</th>
            <th>Ruta</th>
            <th className="rounded-r-lg">Propietario</th>
          </tr>
        </thead>
        <tbody className="text-sm text-text">
          {data.map((item, index) => (
            <tr key={index} className="[&>td]:py-3 [&>td]:px-1 [&>td]:max-w-36 border-b border-gray6">
              <td>
                <p className="font-bold text-orange text-lg">
                  { item.user?.person?.company?.name }
                </p>
                <p>{ item.user?.person?.company?.documentType?.name }-{ item.user?.person?.company?.document }</p>
              </td>
              <td className="whitespace-pre">
                <p>{ moment(item?.date).format('DD/MM/YYYY') }</p>
                <p>{ moment(item?.date).format('hh:mma') }</p>
              </td>
              <td>
                <span className="font-semibold text-orange text-base">
                  { item?.vehicle?.plaque || '--' }
                </span>
              </td>
              <td>{ item?.driver?.person?.fullName }</td>
              <td>{ item?.route?.name }</td>
              <td>{ item?.vehicle?.owner?.person?.name || 'Maxer' }</td>
            </tr>
          ))}
        </tbody>
      </table>

      <Render condition={isLoading}>
        <div className="flex justify-center items-center py-20">
          <Spinner />
        </div>
      </Render>

      <Render condition={isLoading && !data.length}>
        <p className="py-8 text-text text-center">Sin datos para mostrar</p>
      </Render>
    </main>
  );
};

export default ModalDetails;